'use strict';

import { apiUrl } from '../../app.api.config';

export default class LotosCardsService {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  };
  getList = function (request) {
    return this.$http.post(apiUrl().API_URL + '/admin/lotosCardOrders/dataPage', request);
  };
  getCsv = function(criteria) {
    return this.$http.post(apiUrl().API_URL + '/admin/lotosCardOrders/getCsv?XDEBUG_SESSION_START=PHPSTORM', criteria);
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/model/Lotos-cards.js